<template>
  <div class="m-loader w-full h-screen flex justify-center items-center">
    <div class="lds-ring" :class="spinnerSize">
      <div :class="borderSpinnerColor"></div>
      <div :class="borderSpinnerColor"></div>
      <div :class="borderSpinnerColor"></div>
      <div :class="borderSpinnerColor"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: function (value) {
        // The value must match one of these strings
        return ['primary', 'info', 'danger', 'white'].indexOf(value) !== -1;
      },
    },
    size: {
      type: String,
      default: 'md',
      validator: function (value) {
        // The value must match one of these strings
        return ['sm', 'md', 'lg'].indexOf(value) !== -1;
      },
    },
  },

  computed: {
    borderSpinnerColor() {
      const borderColor = {};
      borderColor[this.variant + '-color-loader'] = true;
      return borderColor;
    },

    spinnerSize() {
      const sizeClass = {};
      sizeClass[this.size + '-loader-size'] = true;
      return sizeClass;
    },
  },
};
</script>

<style scoped lang="scss">
.lds-ring {
  display: inline-block;
  position: relative;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  margin: auto;
  border-style: solid;

  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<style lang="scss">
.primary-color-loader {
  border-color: $primary transparent transparent transparent;
}

.info-color-loader {
  border-color: $info transparent transparent transparent;
}

.danger-color-loader {
  border-color: $danger transparent transparent transparent;
}

.white-color-loader {
  border-color: $white transparent transparent transparent;
}

.sm-loader-size {
  width: 28px;
  height: 28px;

  div {
    border-width: 2px;
    width: calc(28px * 0.796875);
    height: calc(28px * 0.796875);
    margin: calc(28px * 0.796875);
  }
}

.md-loader-size {
  width: 64px;
  height: 64px;

  div {
    border-width: 6px;
    width: 51px;
    height: 51px;
    margin: 6px;
  }
}
</style>
